export default function Home() {
	return (
		<div className='flex-1 d-flex align-items-center justify-content-center'>
			<span className='fs-1'>Bienvenido</span>
		</div>
	)
}
